import {
    ADD_MEMO_STARTED,
    ADD_MEMO_FINISHED,
    ADD_MEMO_FAILED,
    SET_NEW_MEMO
} from 'constants/actionTypes';

export const addMemoStarted = (request, orderId, date) => ({type: ADD_MEMO_STARTED, request, orderId, date});
export const addMemoFinished = (request, orderId, date) => ({type: ADD_MEMO_FINISHED, request, orderId, date});
export const addMemoFailed = (payload, orderId) => ({type: ADD_MEMO_FAILED, payload, orderId});
export const setNewMemo = (memo, orderId) => ({type: SET_NEW_MEMO, memo, orderId});




// WEBPACK FOOTER //
// ./src/actions/accountActions.js